import axios from 'axios';
import connection from './connection';
import {IndentRequest, VehicleAssignmentDTO, VehicleAssignmentResponseModel} from '@gtpl/shared-models/transportation'
import { VehicleNumberReq } from 'libs/shared-models/transportation/src/lib/vehicle-assignment/vehicle-info-req';
import { CommonResponse } from '@gtpl/shared-models/masters';
export class VehicleAssignmentService {
    URL = connection.DEPLOY_URL + '/vehicle-assignment';
    
    async createVehicleAssignment(vehicleAssignmentDTO: VehicleAssignmentDTO): Promise<VehicleAssignmentResponseModel> {
        console.log(vehicleAssignmentDTO);
          return await axios.post(this.URL + '/createVehicleAssignment',vehicleAssignmentDTO)
              .then(res => {
                  return res.data
              })
    }
    async getVehicleAssignDetailsByIndentId(inputData: IndentRequest): Promise<VehicleAssignmentResponseModel> {
          return await axios.post(this.URL + '/getVehicleAssignDetailsByIndentId',inputData)
              .then(res => {
                  return res.data
              })
    }
    async updateVehicleAssignment(vehicleAssignmentDTO: VehicleAssignmentDTO): Promise<VehicleAssignmentResponseModel> {
        console.log(vehicleAssignmentDTO);
          return await axios.post(this.URL + '/updateVehicleAssignment',vehicleAssignmentDTO)
              .then(res => {
                  return res.data
              })
    }
    async getVehicleAssignDetailsByVehicleNum(vehicleAssignmentDTO: VehicleNumberReq): Promise<CommonResponse> {
        console.log(vehicleAssignmentDTO);
          return await axios.post(this.URL + '/getVehicleAssignDetailsByVehicleNum',vehicleAssignmentDTO)
              .then(res => {
                  return res.data
              })
    }
}
